<template>
     <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
          <li class="">
            <router-link to="/admin">Dashboard</router-link>
          </li>
          <li class=""><a v-on:click="$router.go(-1)">Change Role And Permission</a></li>
          <li class="active">Role</li>
        </ol>
        <div class="panel-body locationform">
          <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <form @submit.prevent="submitForm">
            <div class="row">
                  <legend>Add Role</legend>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Role Name *</label>
                      <input
                        v-model="role.name"
                        v-validate="'required'"
                        type="text"
                        placeholder="Name"
                        class="form-control"
                        name="roleName"
                      />
                      <span v-if="errors.has('roleName')">
                        {{ errors.first('roleName') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Description *</label>
                      <input
                        v-model="role.description"
                        v-validate="'required'"
                        type="text"
                        placeholder="Role Descriptions"
                        class="form-control"
                        name="roleDescription"
                      />
                      <span v-if="errors.has('roleDescription')">
                        {{ errors.first('roleDescription') }}
                      </span>
                    </div>
                  </div>
                   <div class="col-md-4">
                        <div class="form-group">
                          <button
                            class="btn-raised btn-primary btn fixcolorAs"
                            :disabled="loading"
                          >
                            <span
                              v-show="loading"
                              class="spinner-border spinner-border-sm"
                            ></span>
                            <span>Submit</span>
                          </button>
                        </div>
                   </div>
            </div>      
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserService from '../../services/user.service';
import VeeValidate from 'vee-validate';

function initialState() {
  return {
          name:'',
          description:''
      }
}
export default {
    name : 'AddRole',
    data() {
        return{
            loading:false,
            SuccessMessage:"",
            ErrorMessage:"",
            role: initialState()
        }
    },
    methods:{
        submitForm(){
        this.$validator.validateAll().then((res) => {
        if (res) {
          let loader = this.$loading.show();
          UserService.postMetod(
            'kspgAPI/RoleAndPermission/Role/add',
            this.role
          ).then(
            (response) => {
              this.SuccessMessage = response.data.message;
              setTimeout(() => (this.SuccessMessage = false), 5000);
              this.loading = false;
              // on success reset values
              if (response.data.status) {
                this.resetWindow();
                /*Clear Validation */
                 this.$nextTick(() => {
                    this.errors.clear();
                    this.$nextTick(() => {
                        this.$validator.reset();
                    });
                });
              }
            },
            (error) => {
              this.loading = false;

              this.ErrorMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
          setTimeout(() => {loader.hide()}, 1000)
        } else {
          this.ErrorMessage = 'Please correct all error!';
        }
      });
    
        },
        resetWindow: function () {
      Object.assign(this.$data.role, initialState());
    },
    }
}
</script>